import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveLatestCourses } from "../../../redux/slice/latest-courses-slice";
import { RootState, useAppDispatch } from "../../../redux/store";

import Card from "../../../widgets/cards";

const FeaturedLearning = () => {
  const { featuredLearningData } = useSelector(
    (state: RootState) => state.latestCourses
  );

  const dispatch = useAppDispatch();
  const numberOfCourses = 1;

  useEffect(() => {
    dispatch(retrieveLatestCourses(numberOfCourses));
  }, [dispatch]);

  var articles = featuredLearningData.map((item, index) => {
    return {
      date: item.availableDate,
      author: "",
      icon: "",
      category: "Featured Learning",
      title: item.name,
      description: item.name,
      img: item.imageUrl,
      alt: item.name,
      showHomePage: true,
      articleURL: `/products/${item.nodeName}`
    };
  });

  var latestArticles = [
    {
      title: "Featured Learning",
      link: "/education/courses",
      article: articles,
    },
  ];

  return <Card cardData={latestArticles} />;
};

export default FeaturedLearning;
